import React, { useState } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';
import { postEditQuestion} from "../../services/callApi";
import { API_QUERY_KEYS, invalidateApiQueries } from "../../utils/apiQueryCache";
import { ManagementIconActionButton } from "../common/ManagementListLayout";

function QuestionDeleteDialog({ problem, onDeleted }) {
  const [open, setOpen] = React.useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const onClose = onDeleted;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (shouldRefresh = false) => {
    setOpen(false);
    if (shouldRefresh && onClose) {
      onClose(); // ダイアログを閉じた後に呼び出す
    }
  };

  const handleDelete = async () => {
    if (isButtonDisabled) {
      return;
    }

    try{
      const requestBody = {
        question_id: problem.questionId,
        question_part: problem.questionPart,
        question_image_name: problem.questionImageName,
        correct_image_name: problem.correctImageName,
        correct_answer: problem.correctAnswer,
        is_active: false,
      };

      // ボタンを無効化
      setIsButtonDisabled(true);

      console.log(JSON.stringify(requestBody));
      // API呼び出し
      await fetchQuestionLDelete(requestBody);
      invalidateApiQueries(
        API_QUERY_KEYS.questionList,
        API_QUERY_KEYS.questionDetail(problem.questionId)
      );
      handleClose(true);
        
    }catch (error) {
        console.error("エラーが発生しました", error);
        alert("問題の削除中にエラーが発生しました");
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const fetchQuestionLDelete = async (param) => {
    await postEditQuestion(param);
  };

  return (
    <React.Fragment>
      <ManagementIconActionButton
        ariaLabel={`問題${problem.questionPart}-${problem.questionId}を削除`}
        tooltip="削除"
        onClick={handleClickOpen}
      >
        <DeleteIcon fontSize="small" />
      </ManagementIconActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          問題削除
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            問題番号 : {problem.questionPart}-{problem.questionId}を削除しますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={isButtonDisabled} onClick={handleDelete}>はい</Button>
          <Button onClick={handleClose} autoFocus>いいえ</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default QuestionDeleteDialog;
